import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {CurvedCard} from 'components/card';
import SectionHeader from 'ferries/Checkout/SectionHeader';

const SectionCard = ({icon, title, headerClassName, children}) => {
  const headerClasses = classnames('border-0 pt-0 px-0', headerClassName);

  return (
    <CurvedCard className='px-3 py-4 mb-3 bg-white' borderRadius='16px'>
      <SectionHeader
        icon={icon}
        title={title}
        className={headerClasses}
      />
      <div className="two-border-bottom-dotted mb-3" />
      <div>
        {children}
      </div>
    </CurvedCard>
  );
};

SectionCard.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  headerClassName: PropTypes.string,
  children: PropTypes.node.isRequired
};

export default SectionCard;
